export const DEFAULT_WEAPONS_SPEED = 300;
export const DEFAULT_SHIELDS_SPEED = 1200;
export const DEFAULT_THRUSTERS_SPEED = 400;
export const DEFAULT_TARGETING_SPEED = 1200;
export const DEFAULT_REACTOR_SPEED = 2400;
